import { gateway } from "../../../../gateway";
import { IBillingMetricsApiResponse, IBillingMetricsData } from "../interfaces/billingSubscriptions.interface";

export const getBillingMetricsAction = async (): Promise<IBillingMetricsData> => {
  const token = sessionStorage.getItem("token");

  const response = await gateway.get<IBillingMetricsApiResponse>("/subscriptions/billing/metrics", {
    headers: {
      Authorization: `${token}`,
    },
  });

  return (
    response.data?.data || {
      totalActiveSubscriptions: 0,
      totalFreeTrials: 0,
      totalCancelled: 0,
      estimatedMRR: 0,
      sections: {},
    }
  );
};
